module.exports = __webpack_public_path__ + "static/img/dzp1.2aa3057.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dzp1.png
// module id = 9wXf
// module chunks = 1